import { jsx } from "react/jsx-runtime";
import {
  styled,
  useProps,
  useTheme
} from "@tamagui/core";
import { YStack } from "@tamagui/stacks";
import {
  LinearGradient as ExpoLinearGradient
} from "./linear-gradient";
const LinearGradient = YStack.styleable((propsIn, ref) => {
  var _a;
  const props = useProps(propsIn);
  const { start, end, colors: colorsProp, locations, children, ...stackProps } = props;
  const theme = useTheme();
  const colors = ((_a = props.colors) == null ? void 0 : _a.map((c) => {
    var _a2;
    return ((_a2 = theme[c]) == null ? void 0 : _a2.get()) ?? c;
  })) || [];
  return /* @__PURE__ */ jsx(LinearGradientFrame, { ref, ...stackProps, children: /* @__PURE__ */ jsx(
    ExpoLinearGradient,
    {
      start,
      end,
      colors,
      locations,
      style: absoluteFill,
      children
    }
  ) });
});
const absoluteFill = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
const LinearGradientFrame = styled(YStack, {
  name: "LinearGradient",
  overflow: "hidden",
  position: "relative"
});
export {
  LinearGradient
};
//# sourceMappingURL=LinearGradient.shared.js.map
